import {Shop} from '@/src/entities/shop'

import {ProductSimpleListItemViewModel} from './list-item-simple'
import {ProductWithVariantsListItemViewModel} from './list-item-with-offers'

export class ProductSimpleViewModel extends ProductSimpleListItemViewModel {
  get warehouseAvailableList() {
    return (_warehouses?: Record<Id, Shop>) => {
      const warehouses = _warehouses ?? {}
      if (!this.available) return []

      const stocks = this.product.stocks ?? []

      return this.getWarehousesByStocks(warehouses, stocks)
    }
  }
}

export class ProductWithVariantsViewModel extends ProductWithVariantsListItemViewModel {
  get warehouseAvailableList() {
    return (_warehouses?: Record<Id, Shop>) => {
      const warehouses = _warehouses ?? {}
      if (!this.available) return []

      const stocks = this.variants.variant?.stocks ?? []

      return this.getWarehousesByStocks(warehouses, stocks)
    }
  }

  async onClickBuyButton(): Promise<void> {
    this.setLoading(true)

    await this.basket?.addProduct(this.product, this.variants.variant ?? undefined)

    this.setLoading(false)
  }
}

export type ProductViewModel = ProductSimpleViewModel | ProductWithVariantsViewModel
